import React from 'react';
import { getRegistrations } from '../service/ItemService';
import { getUserToken } from '../service/UserService';
import ClipLoader from "react-spinners/ClipLoader";
import axios from 'axios';
import {config } from '../config';
import { withRouter } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import UserDataPopup from '../components/UserDataPopup';
import { toast } from 'react-toastify';
import ItemPickerDD2 from '../components/ItemPickerDD2';

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      regs: [],
      allRegs: [],
      originalAllRegs: [],
      isLoading: false,
      changedValues: [],
      showModal: false,
      selectedUserData: null,
      selectedItem: "0",
      selectedFilter: 'all',
      regCountAll: 0,
      regCountEvaluation: 0,
      regCountStatus: 0,
      onlyActives:true,
      selectedRows: [],
      selectedAction: '',
    }
  }
  linkRef = React.createRef();

  componentDidMount(){
    let isAdmin = this.props.loggedIn && JSON.parse(this.props.loggedIn).isAdmin === "1";
    //console.log("isAdmin" + isAdmin);
    if(isAdmin){
      this.loadRegistrations();
    }
    else{
      this.props.history.push("/fooldal");
    }
  }

  loadRegistrations(){
    this.setState({isLoading: true, selectedAction: ""});
    getRegistrations().then(data => {
      console.log("Registrations", data);
      
      this.setState({regs: data, allRegs: data, originalAllRegs: data},
        ()=>{
          this.filterItemsByActive(()=>{
            this.calculateCounts();
            this.setState({isLoading: false, changedValues:[]});
            this.filterItemsById(this.state.selectedItem, ()=>{
              this.filterChanged(this.state.selectedFilter);
            });
          });
      });
    });
  }

  calculateCounts(){
    let regs = this.state.regs;
    let countEvaluation = regs.filter(r =>r.evaluation === null ||  r.evaluation === '-').length;
    let countStatus = regs.filter(r =>r.status === null ||  r.status === 'Jóváhagyásra vár').length;
    this.setState({regCountAll: regs.length, regCountStatus: countStatus, regCountEvaluation: countEvaluation});
  }
  
  downloadCSV(type){
    let url = config.API_URL + '/Item/downloadcsv.php?type='+type+'&item='+this.state.selectedItem;
    console.log("calling url:" + url);
    fetch(url).then(res => {
        return res.blob();
    }).then(blob => {
        const href = window.URL.createObjectURL(blob);
        const a = this.linkRef.current;
        a.download = 'export.csv';
        a.href = href;
        a.click();
        a.href = '';
    })
  }

  saveChanges(){
    console.log("selected action:"+ this.state.selectedAction );
    if(this.state.selectedAction === ""){
      this.saveEvaluations();
    }
    else if(this.state.selectedAction === "reset"){
      this.resetStatuses();
    }
  }

  saveEvaluations(){
    let url = config.API_URL + '/Item/evaluate.php';
    //console.log("calling url:" + url);
    //console.log("JSON.stringify(this.state.item):", JSON.stringify(this.state.changedValues));
    //toast("Változtatások mentése...");
    axios({
        method: 'post',
        url: url,
        //headers: { 'content-type': 'application/json' },
        data: JSON.stringify({changes: this.state.changedValues, token:getUserToken()})
      })
      .then(result => {
        console.log("result", result);
        if(result.data.status === true){
          toast("Sikeres mentés", {type:'info'});
          this.loadRegistrations();
        }
        else{
            alert("error: " + result.data.message);
        } 
      })
      .catch(error => alert(error.message));
  }
  
  resetStatuses(){
    let url = config.API_URL + '/Item/resetStatus.php';
    axios({
        method: 'post',
        url: url,
        //headers: { 'content-type': 'application/json' },
        data: JSON.stringify({regids: this.state.selectedRows, token:getUserToken()})
      })
      .then(result => {
        console.log("result", result);
        if(result.data.status === true){
          toast("Sikeres törlés", {type:'info'});
          this.loadRegistrations();
        }
        else{
            alert("error: " + result.data.message);
        } 
      })
      .catch(error => alert(error.message));
  
  }

  selectChanged(regid, select, event){
    let regs = [...this.state.regs];
    let index = regs.findIndex(i=> i.regid === regid);
    let changedItem = regs[index] 
    changedItem[select] = event.target.value;
    regs[index] = changedItem;

    this.setState({regs});
    let changedValues = [...this.state.changedValues];
    let changeIndex = changedValues.findIndex(v => v.regid === regid && v.select === select);
    //console.log("changeIndex:", changeIndex);
    if(changeIndex >= 0){
      //let changedValueItem = changedValues[changeIndex]
      changedValues[changeIndex] = {regid, select, value: event.target.value};
    }
    else{
      changedValues.push({regid, select, value: event.target.value});
    }
    this.setState({changedValues});
  }

  openUserDetails(regObj){
    this.setState({showModal: true, selectedUserData: regObj});
  }

  handleCloseModal(){
    this.setState({showModal: false});
  }

  filterChanged(filter){
    this.setState({selectedFilter: filter});
    let allRegs = this.state.allRegs;
    let newRegs = allRegs;
    if(filter === 'evaluation'){
      //console.log("evaluation filter");
      newRegs = allRegs.filter(r=>r.evaluation === null || r.evaluation === '-' );
    }
    else if(filter === 'status'){
      //console.log("status filter");
      newRegs = allRegs.filter(r=>r.status === null || r.status === 'Jóváhagyásra vár' );
    }
    //console.log("if:" + this.state.selectedItem );
    if(this.state.selectedItem !== null && this.state.selectedItem !== "0"){
      //console.log("item filter also");
      newRegs = newRegs.filter(r=>r.item_id === this.state.selectedItem);
    }
    this.setState({regs: newRegs});
  }
  
  itemSelected(itemid){
    this.setState({selectedItem:itemid, selectedFilter: 'all'});
    this.filterItemsById(itemid, ()=>{});
  }

  filterItemsById(itemid, callback){
    //console.log("filter regs by itemid:" + itemid);
    
    let allRegs = this.state.allRegs;
    let newRegs = allRegs;
    if(itemid !== "0"){
      newRegs = allRegs.filter(r=>r.item_id === itemid);
    }
    this.setState({regs: newRegs}, 
      ()=>{
        this.calculateCounts();
        callback();
      }
    );   
  }

  filterItemsByActive(callback){
    if(this.state.onlyActives){
      let regs = this.state.allRegs;
      let onlyActiveRegs = regs.filter(r=> r.isactive === "1");
      console.log("Registrations (active only):", onlyActiveRegs);
      this.setState({regs: onlyActiveRegs, allRegs: onlyActiveRegs},
        ()=>{
          callback();
        });
    }
    else{
      callback();
    }
  }

  resetStatus(regId){
    let conf = window.confirm("Biztos vagy benne, hogy törlöd a mentett értékeket?");
    if(conf){
      let url = config.API_URL + '/Item/resetStatus.php';
      //onsole.log("calling url:" + url);
      //console.log("regid:", regId);
      //toast("Változtatások mentése...");
      axios({
          method: 'post',
          url: url,
          //headers: { 'content-type': 'application/json' },
          data: JSON.stringify({regid: regId, token:getUserToken()})
        })
        .then(result => {
          console.log("result", result);
          if(result.data.status === true){
            toast("Sikeres törlés", {type:'info'});
            this.loadRegistrations();
          }
          else{
              alert("error: " + result.data.message);
          } 
        })
        .catch(error => alert(error.message));
    }
  }

  setOnlyActiveStatus(e){
    this.setState({onlyActives: e.target.checked});
    this.loadRegistrations();
  }

  
  setSelectedRow(e, regId){
    console.log("setSelectedRow" + e.target.checked, regId);
    if(e.target.checked && this.state.selectedRows.indexOf(regId) < 0){
      //console.log("add regid:"+ regId);
      this.setState({selectedRows: [...this.state.selectedRows, regId]});
    }
    else{
      //console.log("remove regid:"+ regId);
      let newRows = this.state.selectedRows;
      newRows = newRows.filter(r => r !== regId);
      this.setState({selectedRows: newRows});
    }
  }

  render(){ 
    return ( 
      <div className="kwizda-admin-container">
        <div className="kwizda-filter-container">
          <ItemPickerDD2 defaultText={"Minden kísérlet"} allItemsOption floatLeft
                itemSelected={(itemid)=> this.itemSelected(itemid)}></ItemPickerDD2>
          <div style={{display:'block', float:'left'}}>
            <div className={this.state.selectedFilter === 'all'? "kwizda-filter kwizda-filter-selected": "kwizda-filter"}
              onClick={() => this.filterChanged('all')}>
              <div className="kwizda-filter-name">Összes nevező</div>
                <span className="kwizda-filter-number">{this.state.regCountAll}</span>
              </div>
            <div className={this.state.selectedFilter === 'evaluation'? "kwizda-filter kwizda-filter-selected": "kwizda-filter"}
              onClick={() => this.filterChanged('evaluation')}>
              <div className="kwizda-filter-name">Értékelésre vár</div>
                <span className="kwizda-filter-number">{this.state.regCountEvaluation}</span>
              </div>
            <div className={this.state.selectedFilter === 'status'? "kwizda-filter kwizda-filter-selected": "kwizda-filter"}
              onClick={() => this.filterChanged('status')}>
              <div className="kwizda-filter-name">Jóváhagyásra vár</div>
                <span className="kwizda-filter-number">{this.state.regCountStatus}</span>
            </div>
          </div>
          <button className="kwizda-button"
            onClick={()=>this.saveChanges()} 
            style={{float:'right', width:200}}>Változtatások mentése</button>
          <button className="kwizda-button"
            onClick={()=>this.loadRegistrations()} 
            style={{float:'right', width:100, marginRight:20}}>Frissítés</button>
        </div>
        <div className="kwizda-admin-groupactions">
          <select className="kwizda-admin-groupactions-dd" value={this.state.selectedAction} onChange={()=>{}}>
            <option value="NULL">Csoportműveletek</option>
            <option value="reset" onClick={()=>this.setState({selectedAction: "reset"})}>Reset</option>
          </select>
        </div>
        <div className="kwizda-admin-onlyactive">
          <input type="checkbox" checked={this.state.onlyActives}
            onChange={(e) => this.setOnlyActiveStatus(e)}
          ></input>
          <span>Csak aktív kísérletek</span>
        </div>
        
        <div style={{float:'right'}}>
          <div className="kwizda-downloadlink"
            onClick={()=> this.downloadCSV("Approved")}>
              <img src="img/CSV_ikon.png" alt="Jóváhagyottak letöltése CSV-ben"></img>
              <span>Jóváhagyottak letöltése CSV-ben</span>
          </div>
          <div className="kwizda-downloadlink" 
            onClick={()=> this.downloadCSV("All")}>
              <img src="img/CSV_ikon.png" alt="Összes letöltése CSV-ben"></img>
              <span>Összes letöltése CSV-ben</span>
          </div>
        </div>
        <table className="kwizda-admin-table" border='1' style={{width:'100%'}}>
          <thead>
          <tr>
            <th><img src="img/reset_icon.png" alt=""></img></th>
            {(this.state.selectedItem=== '0')?<th>Kísérlet</th>:""}
            <th>Regisztráló</th>
            <th>Képek</th>
            <th>Értékelés</th>
            <th>Státusz</th>
            <th>Email</th>
            <th><img src="img/reset_icon.png" alt=""></img></th>
          </tr>
          </thead>
          <tbody>
            {!this.state.isLoading && this.state.regs.map((regObj, i)=> (
              <tr key={i}>
                <td><input type="checkbox" 
                  onChange={(e) => this.setSelectedRow(e, regObj.regid)}
                  ></input>
                </td>
                {(this.state.selectedItem=== '0')?<td>{regObj.name}</td>:""}
                <td className="kwizda-admin-username" 
                  onClick={()=>this.openUserDetails(regObj)}>{regObj.farmer_name}
                </td>
                <td className="kwizda-admin-image-links">
                  {regObj.location_county && (<div><a target='_blank' rel="noreferrer" href={config.API_URL + "/Item/" + regObj.location_county}>1.kép</a></div>)}
                  {regObj.location_city && (<div><a target='_blank' rel="noreferrer" href={config.API_URL + "/Item/" + regObj.location_city}>2.kép</a></div>)}
                  {regObj.location_number && (<div><a target='_blank' rel="noreferrer" href={config.API_URL + "/Item/" + regObj.location_number}>3.kép</a></div>)}
                </td>
                <td>
                  <select disabled={regObj.emailsent==='1'}
                    onChange={(e)=>this.selectChanged(regObj.regid, "evaluation", e)} 
                    value={regObj.evaluation ?? "-"}>
                    <option value="NULL">-</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                </td>
                <td>
                  <select className="kwizda-admin-status-dd" disabled={regObj.emailsent==='1'}
                    onChange={(e)=>this.selectChanged(regObj.regid, "status", e)} 
                    value={regObj.status ?? "Jóváhagyásra vár"}
                    style={(regObj.status==="Jóváhagyva") ? {color:"green"}: 
                              (regObj.status==="Elutasítva") ? {color:"red"}: {}}>
                    <option style={{color:'#444'}} value="NULL">Jóváhagyásra vár</option>
                    <option style={{color:'green'}}>Jóváhagyva</option>
                    <option style={{color:'red'}}>Elutasítva</option>
                  </select>
                </td>
                <td>{regObj.emailsent==='1'?<img src="img/email_icon.png" alt="Email küldve"></img>:""}</td>
                <td>{regObj.emailsent==='1'?<img style={{cursor:"pointer"}} src="img/delete_icon.png" alt="Értékek törlése"
                  onClick={()=>this.resetStatus(regObj.regid)}></img>:""}</td>
              </tr>
              )
            )}
          </tbody>
        </table>
        <input type="hidden" name="changed values" readOnly value={JSON.stringify(this.state.changedValues)}></input>
        <ClipLoader loading={this.state.isLoading} size={80} />
        <Modal show={this.state.showModal} onHide={() => this.handleCloseModal()} >
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedUserData && 
              <UserDataPopup userData={this.state.selectedUserData} allRegs={this.state.originalAllRegs}></UserDataPopup>}
            <button className="kwizda-button kwizda-modal-close-button"
              onClick={() => this.setState({showModal:false})}>
              Vissza a jelentkezések listájához
            </button>
          </Modal.Body>
        </Modal>
        <a ref={this.linkRef}/>
      </div>
     )
  }
}
 
export default withRouter(Admin);
